<template>
    <div class="finished-wrapper tw-flex tw-mx-auto tw-mb-4"
         :class="{'finished': toggle_finished}">
        <div class="mark-finished tw-flex-1 tw-flex tw-rounded-lg tw-items-center">
            <div class="finished-content tw-flex tw-flex-col tw-flex-1">
                <div class="tw-flex tw-text-gray-700 tw-items-center">
                    <i class="fa fa-graduation-cap tw-text-3xl tw-mr-2"></i>
                    <h4 class="tw-text-2xl tw-font-bold"
                        v-text="toggle_finished ? translations['membership.lesson'] + ' ' +  translations['membership.course_finished'] + '!' : translations['membership.lesson'] + ' ' +  translations['membership.course_finished'] + '?'"></h4>
                </div>
                <p class="tw-text-gray-500 tw-text-base" v-text="toggle_finished ? translations['membership.mark_as_unfinished'] : translations['membership.mark_as_finished']" style="font-size: 16px;"></p>
            </div>
            <div class="finish-btn-wrapper tw-ml-2 tw-opacity-50 hover:tw-opacity-100"
                 :class="{'tw-opacity-100': toggle_finished}" @click="complete">
                <div class="finish-btn tw-rounded-full tw-flex tw-items-center tw-justify-center tw-bg-white tw-text-2xl tw-text-gray-400 tw-cursor-pointer">
                    <i class="fa fa-check"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Global from "../../mixins/Global";

    export default {
        name: 'Finished',

        mixins: [Global],

        props: {
            lesson_id: {
                required: true,
                type: Object,
            },
            finished: {
                required: true,
                type: Boolean,
            },
        },

        data() {
            return {
                toggle_finished: false,
            };
        },

        methods: {
            complete() {
                this.$store.dispatch('completeLesson', this.lesson_id).then((response) => {
                    if (response === true) {
                        this.toggle_finished = !this.toggle_finished;
                    }
                });
            },
        },

        mounted() {
            if (this.finished === 'true') {
                this.toggle_finished = true;
            }
        },
    };
</script>

<style lang="scss" scoped>
    .finished-wrapper {
        a {
            //width: 10%;
            width: 8%;
        }

        .mark-finished {
            transition: background-color 0.15s ease;

            .finish-btn-wrapper {
                transition: border 0.15s ease;
                border-radius: 100%;
                border: 2px solid transparent;

                .finish-btn {
                    transition: transform 0.15s ease, color 0.15s ease;
                    width: 55px;
                    height: 55px;
                    box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.05);

                    &:hover {
                        transform: scale(1.15);
                    }
                }
            }
        }

        .finished-nav-btn-wrapper {
            transition: width 0.2s, font-size 0.2s, opacity 0.2s;
        }

        &.finished {
            .mark-finished {
                .finish-btn-wrapper {
                    .finish-btn {
                        @apply tw-bg-green-500 tw-text-white;
                    }
                }
            }

            .finished-nav-btn-wrapper {
                width: 12%;
                font-size: 4rem;
                opacity: 1;
            }
        }

        @media(max-width: 1170px) {
            width: 650px;
        }

        @media(max-width: 1100px) {
            width: 98%;

            a {
                width: 10%;
            }

            .mark-finished {
                @apply tw-p-5;

                .finished-content {
                    i {
                        @apply tw-text-2xl;
                    }

                    h4 {
                        @apply tw-text-xl;
                    }

                    p {
                        @apply tw-leading-relaxed;
                    }
                }

                .finish-btn-wrapper {
                    .finish-btn {
                        @apply tw-text-2xl;
                        width: 50px;
                        height: 50px;
                    }
                }
            }

            &.finished {
                .finished-nav-btn-wrapper {
                    font-size: 3.25rem;
                }
            }
        }
    }
</style>
